import { useReactiveVar } from '@apollo/client'
import { useRouter } from 'next/router'
import React from 'react'

import AddIcon from '@public/svg/icons/add.svg'

import PopButton from '@forms/PopButton'

import { currentAccountUser } from '@lib/apollo/apolloCache'
import { serializeData } from '@lib/tracking'
import { hasPermission } from '@lib/userAuth'

const CompaniesActions = () => {
  const router = useRouter()
  const accountUser = useReactiveVar(currentAccountUser)

  if (!hasPermission.ADMIN(accountUser)) return null

  return (
    <PopButton
      onClick={() => router.push(`/admin-console/companies/add`)}
      size="small"
      btnStyle="simple"
      style={{ margin: 0 }}
      iconHeight={18}
      svgIconRight={AddIcon}
      data-tracking-info={serializeData({
        id: 'admin-console_add-company-button_click',
      })}
    >
      add a company
    </PopButton>
  )
}

export default CompaniesActions
